import React from 'react'
import PropTypes from 'prop-types'

const InputText = ({ label, handler, normalize, validate, className, ...props }) => {

  const onChangeHandler = (e) => {
    const { value } = e.currentTarget

    if (normalize)
      e.currentTarget.value = normalize(value)

    if (validate) {
      if (!e.currentTarget.value) {
        e.currentTarget.error = undefined
      } else {
        e.currentTarget.error = validate(e.currentTarget.value)
      }
    }

    handler(e)
  }

  return (
    <label className={className}>
      <span>{label}</span>
      <input
        {...props}
        onChange={onChangeHandler}
      />
    </label>
  )
}

InputText.propTypes = {
  type: PropTypes.oneOf(['email', 'text', 'phone']).isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handler: PropTypes.func.isRequired,
  normalize: PropTypes.func,
  validate: PropTypes.func,
  required: PropTypes.bool,
  className: PropTypes.string,
  readOnly: PropTypes.bool
}

export default InputText
